export interface Segment {
  id: number
  name: string
  label: string
}

export enum Segments {
  USERS_READ = 'USERS_READ',
  USERS_WRITE = 'USERS_WRITE',
}
